import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import RQLSearchInput from './RQLSearchInput.jsx';
import htmx from 'htmx.org';

export default class RQLSearchHtmx extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      success: false,
      filter: props.filter || {},
      searchUrl: props.searchUrl,
      target: props.target,
      queryStatus: { result: 0, succeeded: false, applied: false },
    };
  }

  componentDidMount() {
    // submit query if received on mounting
    if (this.props.filter && this.props.filter.query) {
      this.submitEvent();
    }
  }

  updateValue(newQuery) {
    this.setState((prevState) => ({
      queryStatus: { result: 0, succeeded: false, applied: false },
      filter: { ...prevState.filter, query: newQuery },
    })); // set state to indicate user interaction
  }

  submitEvent() {
    let params = {
      target: this.state.target,
      swap: 'outerHTML',
    };
    if (this.state.filter && this.state.filter.query) {
      params['values'] = { search: this.state.filter.query };
    }

    htmx.ajax('GET', this.state.searchUrl, params).then(() => {
      let search = this.state.filter.query
        ? `?search=${this.state.filter.query}`
        : window.location.pathname;
      history.pushState({}, '', search);
    });
  }

  onClear() {
    this.setState({ filter: {} }, () => this.submitEvent());
  }

  render() {
    return (
      <Grid className='RQLSearchGrid'>
        <Grid.Row className='RQLGridRow'>
          <RQLSearchInput
            canCreateFilter={false}
            customSyntax={this.props.customSyntax}
            error={this.state.error}
            filter={this.state.filter}
            querySucceeded={this.state.queryStatus.succeeded}
            onChange={this.updateValue.bind(this)}
            onClear={this.onClear.bind(this)}
            onSubmit={this.submitEvent.bind(this)}
          />
        </Grid.Row>
      </Grid>
    );
  }
}
